import type { ListBuilderList } from '../../../types';
import { createMerchandiserColumns } from '../columns';
import { MERCHANDISER_REQUIRED_FIELDS } from '../shared';

/**
 * All Merchandisers list configuration
 * Shows all merchandiser locations
 */
export const allMerchandisersList: ListBuilderList = {
	id: 'merchandiser-locations',
	cacheTTL: 600000,
	name: 'All Merchandisers',
	type: 'default',
	active: true,
	columns: createMerchandiserColumns(),
	description: 'All merchandiser locations',
	defaultSortId: 'column-location-code-asc',
	filterRules: {
		locationType: {
			defaultValue: [{ id: 'merchandiser', label: 'Merchandiser' }],
		},
	},
	requiredFields: MERCHANDISER_REQUIRED_FIELDS,
	sortOrder: 0,
};
